// Validation - only runs if element exists
const zipElement = document.getElementById('zip');
if (zipElement) {
    zipElement.addEventListener('input', function (e) {
        const zipPattern = /^\d{5}(-\d{4})?$/;
        const zipInput = e.target.value;
        const errorElement = document.getElementById('zip-error');

        if (zipInput.length >= 5) {
            if (!zipPattern.test(zipInput)) {
                errorElement.style.display = 'block';
            } else {
                errorElement.style.display = 'none';
            }
        } else {
            errorElement.style.display = 'none';
        }
    });
}

const apiToken = 'UPewLvmmhicBcxTAdrxpWmgTaKKDRBTn';
const apiBaseUrl = 'https://www.ncdc.noaa.gov/cdo-web/api/v2';
const frostApiBaseUrl = 'https://frost-date-api-eg.vercel.app/api/frost-dates';
const saveApiUrl = 'https://frost-date-api-eg.vercel.app/api/save';

let zipToZoneMap = {};

async function loadZipZoneData() {
    try {
        const response = await fetch('https://cdn.shopify.com/s/files/1/0658/5693/0045/files/zones.csv.csv?v=1736447927');
        const csvText = await response.text();
        const rows = csvText.split('\n');

        rows.forEach((row) => {
            const [zipcode, zone] = row.split(',');
            if (zipcode && zone) {
                const paddedZip = zipcode.trim().padStart(5, '0');
                zipToZoneMap[paddedZip] = zone.trim();
            }
        });
    } catch (error) {
        console.error('Error loading CSV file:', error);
    }
}

function displayZone() {
    const zip = document.getElementById('zip')?.value.trim();
    const hardinessElem = document.getElementById('hardiness');
    const resultElem = document.getElementById('result');

    if (!hardinessElem || !resultElem) return;

    if (zipToZoneMap[zip]) {
        hardinessElem.textContent = `${zipToZoneMap[zip]}`;
        resultElem.style.display = 'block';
    } else {
        hardinessElem.textContent = 'Zone not found for the entered ZIP code.';
        resultElem.style.display = 'block';
    }
}

async function fetchFrostDates() {
    const zip = document.getElementById('zip')?.value.trim();
    const resultElem = document.getElementById('frost');
    
    if (!resultElem) return;
    
    resultElem.textContent = 'Fetching data...';

    try {
        const frostApiResponse = await fetch(`${frostApiBaseUrl}?zipcode=${zip}`);
        if (frostApiResponse.ok) {
            const frostApiData = await frostApiResponse.json();
            if (frostApiData.avg_first_frost_date && frostApiData.avg_last_frost_date) {
                resultElem.innerHTML = `
                        Your average first frost date is <strong id="firstFrost">${frostApiData.avg_first_frost_date}</strong><br>
                        Your average last frost date is <strong id="lastFrost">${frostApiData.avg_last_frost_date}</strong>
                    `;
                return;
            }
        }

        const geocodeResponse = await fetch(`https://nominatim.openstreetmap.org/search?postalcode=${zip}&country=us&format=json`);
        const geocodeData = await geocodeResponse.json();
        if (!geocodeData.length) throw new Error('Invalid ZIP code');
        const lat = Number(geocodeData[0].lat);
        const lon = Number(geocodeData[0].lon);

        const frostDates = await findFrostDates(lat, lon);

        if (!frostDates) throw new Error('No frost data available from nearby USC stations');

        const formatDate = (dayOfYear) => {
            const date = new Date(2010, 0);
            date.setDate(dayOfYear);
            const formatter = new Intl.DateTimeFormat('en-US', {month: 'long', day: 'numeric'});
            return formatter.format(date);
        };

        const lastSpringFrostDate = formatDate(frostDates.lastSpringFrost);
        const firstFallFrostDate = formatDate(frostDates.firstFallFrost);

        resultElem.innerHTML = `
                Your average first frost date is <strong id="firstFrost">${firstFallFrostDate}</strong><br>
                Your average last frost date is <strong id="lastFrost">${lastSpringFrostDate}</strong>
            `;

        await fetch(frostApiBaseUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                zipcode: zip,
                avgFirstFrostDate: firstFallFrostDate,
                avgLastFrostDate: lastSpringFrostDate,
            }),
        });
    } catch (error) {
        resultElem.textContent = `Error: ${error.message}`;
    }
}

async function findFrostDates(lat, lon) {
    const maxExtentIncrement = 2.0;
    const incrementStep = 0.2;
    let extentIncrement = 0.1;
    let uscStations = [];

    while (uscStations.length === 0 && extentIncrement <= maxExtentIncrement) {
        const extent = `${lat - extentIncrement},${lon - extentIncrement},${lat + extentIncrement},${lon + extentIncrement}`;
        const stationResponse = await fetch(`${apiBaseUrl}/stations?extent=${extent}&datatypeid=ANN-TMIN-PRBFST-T28FP50,ANN-TMIN-PRBLST-T28FP50&limit=1`, {
            headers: {token: apiToken}
        });
        const stationData = await stationResponse.json();

        if (stationData.results) {
            uscStations = stationData.results;
        }

        extentIncrement += incrementStep;
    }

    for (const station of uscStations) {
        const stationId = station.id;
        const frostResponse = await fetch(`${apiBaseUrl}/data?datasetid=NORMAL_ANN&datatypeid=ANN-TMIN-PRBFST-T28FP50,ANN-TMIN-PRBLST-T28FP50&stationid=${stationId}&startdate=2010-01-01&enddate=2010-01-01&limit=2`, {
            headers: {token: apiToken}
        });
        const frostData = await frostResponse.json();

        if (frostData.results && frostData.results.length === 2) {
            return frostData.results.reduce((acc, data) => {
                if (data.datatype === 'ANN-TMIN-PRBFST-T28FP50') acc.firstFallFrost = data.value;
                if (data.datatype === 'ANN-TMIN-PRBLST-T28FP50') acc.lastSpringFrost = data.value;
                return acc;
            }, {});
        }
    }

    return null;
}

async function saveDataToLocalStorage() {
    const zip = document.getElementById('zip')?.value.trim();
    const email = document.getElementById('saveEmail')?.value.trim();
    const hardinessZone = document.getElementById('hardiness')?.textContent;
    const avgFirstFrostDate = document.getElementById('firstFrost')?.textContent;
    const avgLastFrostDate = document.getElementById('lastFrost')?.textContent;

    if (!zip || !email || !hardinessZone || !avgFirstFrostDate || !avgLastFrostDate) return;

    const data = {
        zip,
        email,
        hardinessZone,
        frostInfo: {avgFirstFrostDate, avgLastFrostDate}
    };
    localStorage.setItem('gardeningData', JSON.stringify(data));

    try {
        await fetch(saveApiUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                zipcode: zip,
                avgFirstFrostDate,
                avgLastFrostDate,
                zone: hardinessZone,
                email
            })
        });

        const saveDataElem = document.querySelector('.save-data');
        if (saveDataElem) {
            saveDataElem.innerHTML = '<p>✓ Your settings have been saved and sent to the server.</p>';
        }
    } catch (error) {
        console.error('Error saving data to API:', error);
    }
}

function loadDataFromLocalStorage() {
    const savedData = JSON.parse(localStorage.getItem('gardeningData'));
    if (savedData) {
        const resultElem = document.getElementById('result');
        const zipElem = document.getElementById('zip');
        const zipSubmitElem = document.getElementById('zipSubmit');
        const hardinessElem = document.getElementById('hardiness');
        const frostElem = document.getElementById('frost');
        const saveDataElem = document.querySelector('.save-data');

        if (resultElem) resultElem.style.display = 'block';
        if (zipElem) {
            zipElem.value = savedData.zip;
            zipElem.disabled = true;
        }
        if (zipSubmitElem) {
            zipSubmitElem.innerHTML = '✕';
            zipSubmitElem.addEventListener('click', clearLocalStorage);
        }
        if (hardinessElem) hardinessElem.textContent = savedData.hardinessZone;
        if (frostElem) {
            frostElem.innerHTML = `
                Your average first frost date is <strong id="firstFrost">${savedData.frostInfo.avgFirstFrostDate}</strong><br>
                Your average last frost date is <strong id="lastFrost">${savedData.frostInfo.avgLastFrostDate}</strong>
            `;
        }
        if (saveDataElem) saveDataElem.innerHTML = '<p>✓ Your settings have been saved.</p>';
    }
}

function clearLocalStorage() {
    localStorage.removeItem('gardeningData');
    const zipElem = document.getElementById('zip');
    const resultElem = document.getElementById('result');
    const zipSubmitElem = document.getElementById('zipSubmit');

    if (zipElem) {
        zipElem.value = '';
        zipElem.disabled = false;
    }
    if (resultElem) resultElem.style.display = 'none';
    if (zipSubmitElem) {
        zipSubmitElem.innerHTML = '<svg fill="#000000" width="800px" height="800px" viewBox="0 -0.24 28.423 28.423" id="_02_-_Search_Button" data-name="02 - Search Button" xmlns="http://www.w3.org/2000/svg"><path id="Path_215" data-name="Path 215" d="M14.953,2.547A12.643,12.643,0,1,0,27.6,15.19,12.649,12.649,0,0,0,14.953,2.547Zm0,2A10.643,10.643,0,1,1,4.31,15.19,10.648,10.648,0,0,1,14.953,4.547Z" transform="translate(-2.31 -2.547)" fill-rule="evenodd"/><path id="Path_216" data-name="Path 216" d="M30.441,28.789l-6.276-6.276a1,1,0,1,0-1.414,1.414L29.027,30.2a1,1,0,1,0,1.414-1.414Z" transform="translate(-2.31 -2.547)" fill-rule="evenodd"/></svg>';
        zipSubmitElem.removeEventListener('click', clearLocalStorage);
        zipSubmitElem.addEventListener('click', (e) => {
            e.preventDefault();
            startCalculations();
        });
    }
}

function startCalculations() {
    fetchFrostDates();
    displayZone();
}

// Main initialization - only runs if frost-date elements exist
window.addEventListener('DOMContentLoaded', () => {
    // Check if the main frost-date form exists before initializing
    const zipElem = document.getElementById('zip');
    const zipSubmitElem = document.getElementById('zipSubmit');
    
    if (!zipElem || !zipSubmitElem) {
        // Frost-date form doesn't exist on this page, exit gracefully
        return;
    }

    // Initialize the frost-date functionality
    loadZipZoneData();
    loadDataFromLocalStorage();

    zipSubmitElem.addEventListener('click', (e) => {
        e.preventDefault();
        startCalculations();
    });

    zipElem.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            startCalculations();
        }
    });

    const saveForm = document.querySelector('.save-data form');
    if (saveForm) {
        saveForm.addEventListener('submit', (e) => {
            e.preventDefault();
            saveDataToLocalStorage();
        });
    }
});